import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CloudUploadIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M21.96 13.56C21.96 16.24 19.84 18.26 17.06 18.26H6.56C3.9 18.26 2.04 16.6 2.04 14.26C2.04 12.52 3.2 11.06 4.88 10.7C5.28 7.46 7.98 5.16 11.3 5.16C13.74 5.16 16.06 6.56 17.26 9.1C20.24 9.16 21.96 11.16 21.96 13.56ZM3.88 14.26C3.88 15.64 4.96 16.52 6.56 16.52H17.06C18.8 16.52 20.12 15.28 20.12 13.56C20.12 11.9 18.76 10.62 16.88 10.62H15.84C15.1 8.36 13.38 6.94 11.14 6.94C8.8 6.94 6.7 8.62 6.5 12C4.86 12.06 3.88 12.98 3.88 14.26ZM8.16 13.46L11.64 10.12L15.12 13.46L13.96 14.6L11.64 12.34L9.32 14.6L8.16 13.46Z" />
    </SvgIcon>
  );
});
